<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
              <mentee-sidebar-menu :show_menu="false" :show_back_button="true" back_link="menteeReports"/>
                <div class="content-wrapper"  style="padding-left: 165px;">
                <div class="container-wrapper center">
                  <div>
                    <h3 class="d-inline heading text-uppercase">My Repetitions </h3>
                  </div>
                  <div class="border-bottom mt-1 mb-2"></div>
                  <div class="margin-bottom-10"></div>

                    <div class="mentor-container">

                        <div class="db-card">
                            <div id="dbRecords" v-if="repetition_count > 0">
                                <div class="reps_card" v-if="this.repetition_count == 0">
                                    <div class="row">
                                        <div class="col-12">No reps recorded!</div>
                                    </div>
                                </div>
                                <div class="db-report-card" v-for="(item, index) in repetitions" :key="index" v-else>
                                    <div class="row">
                                        <div class="col-6 ">{{ '#' + (repetitions.length - index) + ' - ' + item.description }} </div>
                                        <div class="col-6 text-right">{{ item.createdAt | formatDate }} </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div v-if="item.score" class="col-4"><span class="">Rating: </span>{{ item.score }}</div>
                                        <div v-else class="col-4">&nbsp;</div>
                                        <div class="col-8 text-right"><span class="">Time on Task: </span>{{ item.timeOnTask | formatHourMin }}</div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12"><span class="">Mentor: </span>{{ item.mentor_name }}</div>
                                    </div>
                                    <div class="row mt-2">
                                        <div v-if="item.score" class="col-12"><span class="">Comment: </span>{{ item.comment }}</div>
                                    </div>
                                    <div class="border-bottom mt-1 mb-2" style="margin-left: -20px;"></div>
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';
import UserMenu from '../shared/user_menu.vue';
import { store } from '../../store/store';
import MenteeSidebarMenu from '@/components/shared/mentee_sidebar_menu.vue';

export default {
    data: function () {
        return {
            repetition_count: 0,
            repetitions: [],
        }
    },
    components: {
        UserMenu,
        MenteeSidebarMenu,
    },
    methods: {
        getMyRepetitions() {
            axios.get('/desktop/mentee-recent-repetitions/' + this.$store.state.user_accountid, {
            })
            .then(response =>  {
                this.repetition_count = response.data.length;
                this.repetitions = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        goToDashboard() {
            var url = '/mentee-dashboard';
            if(store.state.roles.indexOf('ROLE_APPRENTICE') > -1) {
                url = "/apprentice-dashboard";
            }
            router.push(url);
        }
    },
    mounted() {
      this.getMyRepetitions();
    }
}
</script>
<style scoped>
.mentor-container {
  margin: 0px auto;
  width: 75%;
  padding-top: 0px;
}
.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .acc-info {
  font-size: 13px;
  font-weight: 600;
  margin-left: 10px;
}
.db-card .db-report-card {
  background-color: #FFF;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #FFF;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.back-button {
    color: #002F42;
    font-weight: 900;
    padding-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/see_all_repetitions.vue